import React, { useEffect } from 'react'
import { IProps } from './Interface'
import PageViewRegisterService from './Service'

const Provider: React.FC<IProps> = ({ location, children }) => {
  useEffect(() => {
    async function registerPageViewEvent() {
      if (PageViewRegisterService.state.path !== location) {
        await PageViewRegisterService.registerPath(location)
      }
    }
    registerPageViewEvent()
  }, [location])

  return <React.Fragment>{children}</React.Fragment>
}

export default Provider
